import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Add as AddIcon, Delete, Edit } from "@mui/icons-material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { TreeListTextFilter } from "@progress/kendo-react-treelist";
import { validateAndEnsureArray } from "../../../utils/jsonValidator";

export const cellWithEditing = (handleEdit, handleDelete, propertys) => ({ dataItem }) => {
    const handleClick = (fn, action) => () => fn(dataItem, action);

    const renderButton = (title, color, Icon, fn, action) => (
        <Tooltip key={title} title={title}>
            <IconButton color={color} onClick={handleClick(fn, action)}>
                <Icon />
            </IconButton>
        </Tooltip>
    );

    const hasFunctions = Array.isArray(dataItem?.functions);
    const hasProps =
        dataItem?.[propertys.prop1.key] !== undefined &&
        dataItem?.[propertys.prop2.key] !== undefined;

    const buttons = [];

    if (dataItem?.children) {
        buttons.push(renderButton("Agregar hijo", "primary", AddCircleIcon, handleEdit, "ADDCHILDREN"));
    } else if (hasFunctions || hasProps) {
        buttons.push(renderButton("Editar", "secondary", Edit, handleEdit, "EDIT"));
    }

    buttons.push(renderButton("Eliminar", "error", Delete, handleDelete, "DEL"));

    return <Box display='flex'>{buttons}</Box>;
};

export const formatText = (props) => {
    const { dataItem } = props;
    if (validateAndEnsureArray(dataItem?.functions).length > 0) {
        return (
            <Typography>
                {dataItem.functions.map((item) => item.name).join(", ")}
            </Typography>
        );
    }
    return <Typography></Typography>;
};

export const getColumns = (type, propertys, handleEditFn, handleDelete) => {
    const baseColumns = [
        {
            title: (
                <IconButton
                    size="small"
                    onClick={() => handleEditFn({}, "ADDNEWOBJECT")}
                >
                    <AddIcon fontSize="small" />
                </IconButton>
            ),
            width: "50px",
            cell: cellWithEditing(handleEditFn, handleDelete, propertys),
        },
        {
            field: "field",
            title: "Propiedad",
            width: "500px",
            filter: TreeListTextFilter,
            expandable: true,
        },
    ];

    const parserColumns = [
        { field: "field_value", title: "Valor", width: "200px" },
        { field: "type", title: "Tipo", width: "150px" },
    ];

    const decisionColumns = [
        { field: "operator", title: "Operador", width: "200px" },
        { field: "evaluation_result", title: "Resultado comparar", width: "150px" },
    ];

    const lastColumn = {
        width: "200px",
        title: type === "parser" ? "Funciones" : "Condiciones",
        cell: formatText,
    };

    return [
        ...baseColumns,
        ...(type === "parser" ? parserColumns : decisionColumns),
        lastColumn,
    ];
};
